import React, { Component } from 'react';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';
import PropTypes from 'prop-types';
import RegressionContainer from './RegressionContainer.jsx';
import AcquisitionMetricsContainer from './AcquisitionMetricsContainer.jsx';
import AcquisitionTelemetryContainer from './AcquisitionTelemetryContainer.jsx';
import { connect } from 'react-redux';
import {
  fetchAcquisitionsMetrics,
  fetchAcquisitionsSize,
} from './../actions';
import {
  getAcquisitionsMetrics,
  getAcquisitionsSize,
} from './../reducers';

export class AcquisitionContainer extends Component {
  static propTypes = {
    metrics: PropTypes.object.isRequired,
    size: PropTypes.object.isRequired,
    fetchAcquisitionsMetrics: PropTypes.func.isRequired,
    fetchAcquisitionsSize: PropTypes.func.isRequired
  };

  componentDidMount() {
    this.props.fetchAcquisitionsMetrics();
    this.props.fetchAcquisitionsSize();
  }

  render() {
    return (
      <Tabs defaultActiveKey={1} id="AcquisitionTests">
        <Tab eventKey={1} title="Dispatcher Jobs">
          <RegressionContainer hasCommenting={false} />
        </Tab>
        <Tab eventKey={2} title="Image Creation Duration" >
          <AcquisitionMetricsContainer
            chartData={this.props.metrics}
          />
        </Tab>
        <Tab eventKey={3} title="Image Size" >
          <AcquisitionMetricsContainer
            chartData={this.props.size}
          />
        </Tab>
        <Tab eventKey={4} title="Telemetry" >
          <AcquisitionTelemetryContainer />
        </Tab>
      </Tabs>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    metrics: getAcquisitionsMetrics(state),
    size: getAcquisitionsSize(state)
  };
};

export default connect(
  mapStateToProps,
  {
    fetchAcquisitionsMetrics,
    fetchAcquisitionsSize
  }
)(AcquisitionContainer);


// WEBPACK FOOTER //
// src/Containers/AcquisitionContainer.jsx